import { gateway } from "src/gateway";

export const patchJobAction = async (jobId: string | number, payload: any) => {
    return await gateway.patch(`/jobs/self/${jobId}`, payload);
}